import "@/App.css";
import "@/lib/axios-auth";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import ErrorBoundary from "@/components/ErrorBoundary";
import Home from "@/pages/Home";

// Phase J1.21 (Fév 2026) — Code-splitting des routes lourdes (admin/salarié) :
// l'audit SEO a remonté un bundle JS+CSS de 2,1 Mo unique. En lazy-loadant ces
// pages, seule la home (publique, indexée) charge un bundle minimal — la
// vitesse de la home s'améliore directement, et /menu-moi reste rapide pour
// l'utilisateur authentifié (le chunk est cache-busted par hash).
const ClientConfigurator = lazy(() => import("@/pages/ClientConfigurator"));
const AdminGate = lazy(() => import("@/pages/AdminGate"));
const EmployeePortal = lazy(() => import("@/pages/EmployeePortal"));
const ModeChantier = lazy(() => import("@/pages/ModeChantier"));
const ResetPassword = lazy(() => import("@/pages/ResetPassword"));
const ManuelPage = lazy(() => import("@/pages/ManuelPage"));
const InfraMetrics = lazy(() => import("@/pages/InfraMetrics"));
const PaymentResult = lazy(() => import("@/pages/PaymentResult"));
const DepositPay = lazy(() => import("@/pages/DepositPay"));
const SoldePay = lazy(() => import("@/pages/SoldePay"));

function RouteFallback() {
  return (
    <div className="pt-32 min-h-screen flex items-center justify-center text-slate-400 text-sm mono">
      Chargement…
    </div>
  );
}

function NotFound() {
  return (
    <main className="pt-32 min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="font-display text-6xl font-extrabold text-gold-grad mb-4">
          404
        </div>
        <p className="text-slate-400">Page introuvable.</p>
      </div>
    </main>
  );
}

function Route_(scope, element) {
  // Wrap each route in an isolated ErrorBoundary so a crash on /menu-moi
  // doesn't unmount the navbar / other routes.
  return (
    <ErrorBoundary scope={scope}>
      <Suspense fallback={<RouteFallback />}>{element}</Suspense>
    </ErrorBoundary>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={Route_("home", <Home />)} />
          <Route path="/client" element={Route_("client", <ClientConfigurator />)} />
          <Route path="/menu-moi" element={Route_("admin", <AdminGate />)} />
          <Route path="/menu-salarie" element={Route_("employee", <EmployeePortal />)} />
          <Route path="/chantier" element={Route_("chantier", <ModeChantier />)} />
          <Route path="/reset-password" element={Route_("reset", <ResetPassword />)} />
          <Route path="/manuel" element={Route_("manuel", <ManuelPage />)} />
          <Route path="/infra" element={Route_("infra", <InfraMetrics />)} />
          <Route path="/payment/success" element={Route_("payment", <PaymentResult outcome="success" />)} />
          <Route path="/payment/cancel" element={Route_("payment", <PaymentResult outcome="cancel" />)} />
          <Route path="/payer-acompte/:projectId" element={Route_("deposit", <DepositPay />)} />
          <Route path="/payer-solde/:projectId" element={Route_("solde", <SoldePay />)} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
